import React from 'react';
import { HiX, HiDownload } from 'react-icons/hi';

const DocumentPreview = ({ document, onClose }) => {
  const isImage = document.fileType?.startsWith('image/');
  const isPdf = document.fileType === 'application/pdf';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content max-w-3xl w-full max-h-[90vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-ink-900 truncate">{document.name}</h3>
          <div className="flex items-center gap-2 flex-shrink-0">
            <a
              href={document.storageUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-lg flex items-center justify-center text-ink-400 hover:bg-surface-100 hover:text-ink-600 transition-colors"
              title="Download"
            >
              <HiDownload className="text-lg" />
            </a>
            <button onClick={onClose} className="w-8 h-8 rounded-lg flex items-center justify-center text-ink-400 hover:bg-surface-100 hover:text-ink-600 transition-colors">
              <HiX className="text-lg" />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-auto rounded-lg bg-surface-50 flex items-center justify-center min-h-0">
          {isImage && (
            <img
              src={document.storageUrl}
              alt={document.name}
              className="max-w-full max-h-[70vh] object-contain"
            />
          )}
          {isPdf && (
            <iframe
              src={document.storageUrl}
              title={document.name}
              className="w-full h-[70vh] border-0"
            />
          )}
          {!isImage && !isPdf && (
            <div className="text-center py-16">
              <p className="text-ink-400 font-medium">Preview not available for this file type</p>
              <a
                href={document.storageUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary inline-flex items-center gap-2 mt-4"
              >
                <HiDownload className="text-base" />
                Download File
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentPreview;
